export function capitalizeFirstLetter(str: string | null | undefined): string {
    if (str === null || str === undefined) {
      return 'N/A';
    }
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }